import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer>
      <p>&copy; 2024 Judging App. All rights reserved.</p>
    </footer>
  );
};

export default Footer;